module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "size": "confirm_size",
      "title": "Leave Discussion"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full py-4 px-6"
  }, [_c('div', {
    staticClass: "flex flex-grow h-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between space-x-2"
  }, [_c('button', {
    staticClass: "bg-gray-50 hover:bg-gray-100 w-full border font-poppins border-solid border-gray-200 text-gray-800 rounded py-2 px-4",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Stay here!")]), _vm._v(" "), _c('button', {
    staticClass: "bg-primary hover:bg-primary-dark w-full border border-solid border-primary text-white rounded py-2 px-4 flex justify-center items-center space-x-2",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm_accepted')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chart-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins"
  }, [_vm._v("Go to Reports")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-55f2f62a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/Modals/LeaveModal.vue
// module id = 1898
// module chunks = 61